<template>
    <Button v-if="available" :variant="variant" size="big" @click="navigate">
        {{ $t("stock-add-to-collection") }}
    </Button>
    <AddAdButton v-else :variant="variant" />
</template>

<script setup>
import Button from "@components/ui/button";
import AddAdButton from "@components/layout/navbar/add-ad-button";

defineProps({
    variant: {
        type: String,
        default: 'accent'
    }
});

// CataloguePost shown on the catalogue detail page, shared by pages/catalogue/[slug].vue.
const cataloguePost = useState('catalogue.detail', () => null);

const { available, navigate } = useStockCollection(() => cataloguePost.value);

</script>
